import React, { useState } from "react";
import { Button, Drawer, Space } from "@mantine/core";
import PageHeading from "../../../themes/components/PageHeading";
import AnnouncementForm from "../components/AnnouncementForm";
import AnnouncementTable from "../components/AnnouncementTable";
import PermissionProtectedComponent from "../../../common/uac/PermissionProtectedComponent";
import {
  PERMISSION_ADD_ANNOUNCEMENT,
  PERMISSION_DELETE_ANNOUNCEMENT,
} from "../../../utils/UserAccessControlUtils";
import AnnouncementCloseMultipleButton from "../elements/AnnouncementCloseMultipleButton";
import PageContainer from "../../../themes/components/PageContainer";
import Announcement from "../services/model/Announcement";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";
import NotFound from "../../../common/pages/NotFound";

const AnnouncementDirectoryPage: React.FC = () => {
  const [opened, setOpened] = useState(false);
  const [selection, setSelection] = useState<Announcement[]>([]);

  const { hasPermissions } = React.useContext(AccessPermissionContext);

  if (!hasPermissions) {
    return <NotFound />;
  }

  return (
    <PageContainer>
      <Drawer
        opened={opened}
        size="xl"
        onClose={() => setOpened(false)}
        title="New Announcement"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div style={{ padding: "25px", height: "100%", overflow: "auto" }}>
          <AnnouncementForm onSuccess={() => setOpened(false)} />
        </div>
      </Drawer>
      <PageHeading title="Announcements">
        <PermissionProtectedComponent
          requiredViewPermissions={[
            PERMISSION_ADD_ANNOUNCEMENT,
            PERMISSION_DELETE_ANNOUNCEMENT,
          ]}
        >
          <AnnouncementCloseMultipleButton announcements={selection} />
        </PermissionProtectedComponent>
        <PermissionProtectedComponent
          requiredViewPermissions={[PERMISSION_ADD_ANNOUNCEMENT]}
        >
          <Button
            type="button"
            onClick={() => setOpened(true)}
            variant="filled"
            className="inline-flex"
            color="jem-theme"
          >
            Create New
          </Button>
        </PermissionProtectedComponent>
      </PageHeading>
      <Space h="xl" />
      <AnnouncementTable onSelection={setSelection} selection={selection} />
    </PageContainer>
  );
};

export default AnnouncementDirectoryPage;
